import { render, staticRenderFns } from "./DialogAddEditPhotos.vue?vue&type=template&id=921b0d6c&scoped=true&"
import script from "./DialogAddEditPhotos.vue?vue&type=script&lang=js&"
export * from "./DialogAddEditPhotos.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddEditPhotos.vue?vue&type=style&index=0&id=921b0d6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921b0d6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('921b0d6c')) {
      api.createRecord('921b0d6c', component.options)
    } else {
      api.reload('921b0d6c', component.options)
    }
    module.hot.accept("./DialogAddEditPhotos.vue?vue&type=template&id=921b0d6c&scoped=true&", function () {
      api.rerender('921b0d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/pcManage/photoManage/components/DialogAddEditPhotos.vue"
export default component.exports